"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBase32AddressFromAddress = exports.getLisk32AddressFromAddress = exports.getAddressFromBase32Address = exports.getAddressFromLisk32Address = exports.validateBase32Address = exports.validateLisk32Address = exports.getBase32AddressFromPassphrase = exports.getLisk32AddressFromPassphrase = exports.getBase32AddressFromPublicKey = exports.getLisk32AddressFromPublicKey = exports.verifyChecksum = exports.createChecksum = exports.getAddressFromPrivateKey = exports.getAddressFromPassphrase = exports.getAddressAndPublicKeyFromPassphrase = exports.getAddressFromPublicKey = exports.getKeys = exports.getPrivateAndPublicKeyFromPassphrase = void 0;

var constants_1 = require("./constants");

var convert_1 = require("./convert");

var hash_1 = require("./hash");

var nacl_1 = require("./nacl");

var getPrivateAndPublicKeyFromPassphrase = function getPrivateAndPublicKeyFromPassphrase(passphrase) {
  var hashed = hash_1.hash(passphrase, 'utf8');
  return nacl_1.getKeyPair(hashed);
};

exports.getPrivateAndPublicKeyFromPassphrase = getPrivateAndPublicKeyFromPassphrase;
exports.getKeys = exports.getPrivateAndPublicKeyFromPassphrase;

var getAddressFromPublicKey = function getAddressFromPublicKey(publicKey) {
  var buffer = hash_1.hash(publicKey);
  var truncatedBuffer = buffer.slice(0, constants_1.BINARY_ADDRESS_LENGTH);

  if (truncatedBuffer.length !== constants_1.BINARY_ADDRESS_LENGTH) {
    throw new Error('The Lisk addresses must contains exactly 20 bytes');
  }

  return truncatedBuffer;
};

exports.getAddressFromPublicKey = getAddressFromPublicKey;

var getAddressAndPublicKeyFromPassphrase = function getAddressAndPublicKeyFromPassphrase(passphrase) {
  var _exports$getKeys = exports.getKeys(passphrase),
      publicKey = _exports$getKeys.publicKey;

  var address = exports.getAddressFromPublicKey(publicKey);
  return {
    address: address,
    publicKey: publicKey
  };
};

exports.getAddressAndPublicKeyFromPassphrase = getAddressAndPublicKeyFromPassphrase;

var getAddressFromPassphrase = function getAddressFromPassphrase(passphrase) {
  var _exports$getKeys2 = exports.getKeys(passphrase),
      publicKey = _exports$getKeys2.publicKey;

  return exports.getAddressFromPublicKey(publicKey);
};

exports.getAddressFromPassphrase = getAddressFromPassphrase;

var getAddressFromPrivateKey = function getAddressFromPrivateKey(privateKey) {
  var publicKey = nacl_1.getPublicKey(privateKey);
  return exports.getAddressFromPublicKey(publicKey);
};

exports.getAddressFromPrivateKey = getAddressFromPrivateKey;
var GENERATOR = [0x3b6a57b2, 0x26508e6d, 0x1ea119fa, 0x3d4233dd, 0x2a1462b3];

var polymod = function polymod(uint5Array) {
  var chk = 1;

  var _iterator = _createForOfIteratorHelper(uint5Array),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;
      var top = chk >> 25;
      chk = (chk & 0x1ffffff) << 5 ^ value;

      for (var i = 0; i < 5; i += 1) {
        if (top >> i & 1) {
          chk ^= GENERATOR[i];
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return chk;
};

var createChecksum = function createChecksum(uint5Array) {
  var values = uint5Array.concat([0, 0, 0, 0, 0, 0]);
  var mod = polymod(values) ^ 1;
  var result = [];

  for (var p = 0; p < 6; p += 1) {
    result.push(mod >> 5 * (5 - p) & 31);
  }

  return result;
};

exports.createChecksum = createChecksum;

var verifyChecksum = function verifyChecksum(integerSequence) {
  return polymod(integerSequence) === 1;
};

exports.verifyChecksum = verifyChecksum;

var addressToLisk32 = function addressToLisk32(address) {
  var byteSequence = [];

  var _iterator2 = _createForOfIteratorHelper(address),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var b = _step2.value;
      byteSequence.push(b);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var uint5Address = convert_1.convertUIntArray(byteSequence, 8, 5);
  var uint5Checksum = exports.createChecksum(uint5Address);
  return convert_1.convertUInt5ToBase32(uint5Address.concat(uint5Checksum));
};

var getLisk32AddressFromPublicKey = function getLisk32AddressFromPublicKey(publicKey) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.DEFAULT_LISK32_ADDRESS_PREFIX;
  return "".concat(prefix).concat(addressToLisk32(exports.getAddressFromPublicKey(publicKey)));
};

exports.getLisk32AddressFromPublicKey = getLisk32AddressFromPublicKey;
exports.getBase32AddressFromPublicKey = exports.getLisk32AddressFromPublicKey;

var getLisk32AddressFromPassphrase = function getLisk32AddressFromPassphrase(passphrase) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.DEFAULT_LISK32_ADDRESS_PREFIX;

  var _exports$getAddressAn = exports.getAddressAndPublicKeyFromPassphrase(passphrase),
      publicKey = _exports$getAddressAn.publicKey;

  return exports.getLisk32AddressFromPublicKey(publicKey, prefix);
};

exports.getLisk32AddressFromPassphrase = getLisk32AddressFromPassphrase;
exports.getBase32AddressFromPassphrase = exports.getLisk32AddressFromPassphrase;
var LISK32_ADDRESS_LENGTH = 41;
var LISK32_CHARSET = 'zxvcpmbn3465o978uyrtkqew2adsjhfg';

var validateLisk32Address = function validateLisk32Address(address) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.DEFAULT_LISK32_ADDRESS_PREFIX;

  if (address.length !== LISK32_ADDRESS_LENGTH) {
    throw new Error('Address length does not match requirements. Expected 41 characters.');
  }

  var addressPrefix = address.substring(0, 3);

  if (addressPrefix !== prefix) {
    throw new Error("Invalid address prefix. Actual prefix: ".concat(addressPrefix, ", Expected prefix: ").concat(prefix));
  }

  var addressSubstringArray = address.substring(3).split('');

  if (!addressSubstringArray.every(function (char) {
    return LISK32_CHARSET.includes(char);
  })) {
    throw new Error("Invalid character found in address. Only allow characters: 'abcdefghjkmnopqrstuvwxyz23456789'.");
  }

  var integerSequence = addressSubstringArray.map(function (char) {
    return LISK32_CHARSET.indexOf(char);
  });

  if (!exports.verifyChecksum(integerSequence)) {
    throw new Error('Invalid checksum for address.');
  }

  return true;
};

exports.validateLisk32Address = validateLisk32Address;
exports.validateBase32Address = exports.validateLisk32Address;

var getAddressFromLisk32Address = function getAddressFromLisk32Address(base32Address) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.DEFAULT_LISK32_ADDRESS_PREFIX;
  exports.validateLisk32Address(base32Address, prefix);
  var base32AddressNoPrefixNoChecksum = base32Address.substring(prefix.length, base32Address.length - 6);
  var addressArray = base32AddressNoPrefixNoChecksum.split('');
  var integerSequence = addressArray.map(function (char) {
    return LISK32_CHARSET.indexOf(char);
  });
  var integerSequence8 = convert_1.convertUIntArray(integerSequence, 5, 8);
  return Buffer.from(integerSequence8);
};

exports.getAddressFromLisk32Address = getAddressFromLisk32Address;
exports.getAddressFromBase32Address = exports.getAddressFromLisk32Address;

var getLisk32AddressFromAddress = function getLisk32AddressFromAddress(address) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.DEFAULT_LISK32_ADDRESS_PREFIX;
  return "".concat(prefix).concat(addressToLisk32(address));
};

exports.getLisk32AddressFromAddress = getLisk32AddressFromAddress;
exports.getBase32AddressFromAddress = exports.getLisk32AddressFromAddress;